export default __webpack_public_path__ + "static/media/Archer's Serpentweave.ca78d01f.jpg";